/**
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * * * * * * AUTO GENERATED FILE - DO NOT EDIT ! * * * * * * *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 */
export type CookieJar = {
    [origin: string]: string[]
}
export interface CallParams {
    resource: string
    query?: Query<any, any>
    regularQueryParams?: {
        [key: string]: any
    }
    body?: any
    optionsOverrides?: Partial<RequestOptions>
}
type RequestParams = Pick<RequestOptions, 'method' | 'url' | 'body'> & {
    optionsOverrides?: Partial<RequestOptions>
}
import { ApplianceRegistration, GetSoftwareRequest } from '../api/model/applianceRegistration'
import { EnhancedInputConfig } from '../api/v1/internal'
import { ExternalRegionMessage } from '../api/v1/internal/region'
import {
    AdAuditFilter,
    AdBreak,
    AdBreakFilter,
    AdBreakInit,
    AdCreative,
    AdCreativeEventInit,
    AdCreativeFilter,
    AdCreativeInit,
    AdCreativeUpdate,
    AdCreativeWithUrls,
    AdPod,
    AdPodFilter,
    AdPodInit,
    AdPodUpdate,
    AdStorageStatus,
    Alarm,
    AlarmFilter,
    AlarmLogFilter,
    AlarmUpdate,
    AlarmWithImpact,
    AllocateApplianceRequest,
    ApiToken,
    ApiTokenCreated,
    ApiTokenInit,
    Appliance,
    ApplianceCommandInfo,
    ApplianceCommandInit,
    ApplianceFilter,
    ApplianceInputInfo,
    ApplianceOutputInfo,
    AppliancePhysicalPortInfo,
    ApplianceSummary,
    ApplianceSummaryFilter,
    ApplianceSummarySortableField,
    ApplianceType,
    AuditFilter,
    AuditLog,
    BackupInit,
    BackupMonitorAlarm,
    BatchDeleteResult,
    BeginSystemUpgradeEvent,
    BeginSystemUpgradeResponse,
    BillingReport,
    BuildInfo,
    CloudApplianceAuditLogEntry,
    CommandReceipt,
    CompleteSystemUpgradeEvent,
    CoreSecret,
    CoreVideoApplianceAllocation,
    DeletedInput,
    EchoRequest,
    Entity,
    GeoAppliance,
    GeoApplianceFilter,
    GetImageTagResult,
    GetUsageReportFilter,
    GlobalSettings,
    GrafanaDashboard,
    Group,
    GroupFilter,
    GroupInit,
    GroupInputPermission,
    GroupListInputPermission,
    GroupOrGroupRecipientList,
    GroupRecipientList,
    GroupRecipientListFilter,
    GroupRecipientListInit,
    GroupRecipientListSortableField,
    GroupRecipientListUpdate,
    GroupUpdate,
    ImageDetails,
    ImageTagOperation,
    Ingress,
    Input,
    InputAdminStatusUpdate,
    InputFilter,
    InputGraphFilter,
    InputInit,
    InputPcapRequest,
    InputPcapResponse,
    InputRecipientsUpdate,
    InputStatus,
    InputStreamGraphDebug,
    InputUpdate,
    InternalApplianceStatus,
    IpMappingFilter,
    IpMappingRead,
    IpMappingWrite,
    K8SDeployment,
    KubernetesNode,
    KubernetesNodeFilter,
    KubernetesNodeResourceUsage,
    ListAlarmSortableField,
    ListApplianceSortableField,
    ListGroupSortableField,
    ListInputSortableField,
    ListIpMappingSortableField,
    ListKubernetesNodeSortableField,
    ListOutputSortableField,
    ListPortSortableField,
    ListResult,
    ListServiceSortableField,
    ListUserSortableField,
    LogBatch,
    LoginMethod,
    LoginRequest,
    LoginResult,
    MaxBitrates,
    MetadataTag,
    NdiSource,
    Network,
    NetworkFilter,
    NetworkSortableField,
    NewUser,
    OidcMetadata,
    Output,
    OutputAdminStatusUpdate,
    OutputFilter,
    OutputInit,
    OutputListFilter,
    OutputListSortableField,
    OutputOrRecipientList,
    OutputRecipientList,
    OutputRecipientListInit,
    OutputRecipientListUpdate,
    OutputStatus,
    OutputSwitchInput,
    OutputUpdate,
    Overlay,
    Pcap,
    PhysicalPort,
    Pod,
    PodStatus,
    PortFilter,
    Region,
    RegionFilter,
    RegionInit,
    RegionSortableField,
    RerouteInputPayload,
    RpcSession,
    RpcSessionFilter,
    S3ConfigWithPath,
    SamlMetadata,
    SanityStatus,
    ScaleOperation,
    ScaleStatus,
    Scte104Injection,
    Scte104InjectionResult,
    SearchableFilter,
    SendToOutputRecipientListParams,
    Service,
    ServiceFilter,
    ServiceOverview,
    ServiceUpdate,
    SharedPort,
    SleepResult,
    SortOrder,
    StatusResult,
    SuccessResult,
    TagFilter,
    ThumbRoute,
    TlsCertRead,
    TlsCertWrite,
    Tunnel,
    TunnelFilter,
    TunnelOutputInfo,
    UpdateAppliancePayload,
    UpdateImageRequest,
    UpdateKubernetesNodePayload,
    UpgradeCommandReceipt,
    UpgradeImageArguments,
    UsageReport,
    User,
    UserFilter,
    UserSettings,
    UserUpdate,
} from '../api/v1/types'
import { AuthenticatedUser } from '../http/httpTypes'
import { ApplianceConfiguration } from '../messages'
import { RequestOptions, RequestResult } from '../network/request-options'
import { Query, toQueryParams } from '../query'
import {
    AdAuditLogMessage,
    AdServer,
    AdServerInit,
    AdStageStatsMessage,
    ApplianceCommandProgress,
    ApplianceRegistrationResponse,
    JsonRpcSuccessResponse,
    Message,
    RtmpStatsMessage,
    SrtStatsMessage,
    VersionMessage,
    ZixiBroadcasterStatsMessage,
} from '../types'
export abstract class EdgeClient {
    protected readonly apiKey?: string
    protected readonly cookieJar: CookieJar = {}
    private readonly baseUrls: Iterator<string> & {
        length: number
        reset: () => string
    }
    private _baseUrl: string
    private _baseUrlLastSet: number
    protected constructor(params: { baseUrl: string; apiKey?: string; failbackUrls?: string[] }) {
        this.apiKey = params.apiKey
        const baseUrlList = [...new Set([params.baseUrl, ...(params.failbackUrls ?? [])])]
        let currentUrl = 0
        this.baseUrls = {
            get length() {
                return baseUrlList.length
            },
            reset() {
                currentUrl = 0
                return baseUrlList[currentUrl]
            },
            next: () => {
                currentUrl = (currentUrl + 1) % baseUrlList.length
                return { value: baseUrlList[currentUrl], done: false }
            },
        }
        this._baseUrl = baseUrlList[0]
        this._baseUrlLastSet = Date.now()
    }
    async health(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<string>({
            resource: `/health`,
            optionsOverrides,
        })
        return result.body
    }
    async listStatuses(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<
            ListResult<
                {
                    name?: string
                } & StatusResult
            >
        >({
            resource: `/api/status`,
            optionsOverrides,
        })
        return result.body
    }
    async createApiToken(body: ApiTokenInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<ApiTokenCreated>({
            resource: `/api/api-token/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listApiTokens(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<ApiToken>>({
            resource: `/api/api-token/`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteApiToken(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/api-token/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async setApiTokenEnsureOperatorToken(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<void>({
            resource: `/api/api-token/ensure-operator-token`,
            optionsOverrides,
        })
        return result.body
    }
    async getIpMapping(region: string, privateIp: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<IpMappingRead>({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            optionsOverrides,
        })
        return result.body
    }
    async updateIpMapping(
        region: string,
        privateIp: string,
        body: IpMappingWrite,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<IpMappingRead>({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listIpMappings(
        query?: Query<IpMappingFilter, SortOrder<ListIpMappingSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<IpMappingRead[]>({
            resource: `/api/ip-mapping/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createIpMapping(body: IpMappingWrite, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<IpMappingRead[]>({
            resource: `/api/ip-mapping/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteIpMapping(region: string, privateIp: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<IpMappingRead[]>({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            optionsOverrides,
        })
        return result.body
    }
    async createEcho(body: EchoRequest, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<EchoRequest>({
            resource: `/api/echo`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listOverlays(
        query?: Query<SearchableFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Overlay>>({
            resource: `/api/overlay/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createOverlay(body: Overlay, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Overlay>({
            resource: `/api/overlay/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getOverlay(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Overlay>({
            resource: `/api/overlay/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteOverlay(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/overlay/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listAdServers(
        query?: Query<SearchableFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<AdServer>>({
            resource: `/api/adServer/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getAdServer(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AdServer>({
            resource: `/api/adServer/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async createAdServer(body: AdServerInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<AdServer>({
            resource: `/api/adServer/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateAdServer(id: string, body: AdServer, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<AdServer>({
            resource: `/api/adServer/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteAdServer(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/adServer/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async createAdPod(body: AdPodInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<AdPod>({
            resource: `/api/ad-pod/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getAdPod(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AdPod>({
            resource: `/api/ad-pod/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listAdPods(query?: Query<AdPodFilter, SortOrder<string>>, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<AdPod>>({
            resource: `/api/ad-pod/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async updateAdPod(id: string, body: AdPodUpdate, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<AdPod>({
            resource: `/api/ad-pod/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteAdPod(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<AdPod>({
            resource: `/api/ad-pod/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async createAdCreative(body: AdCreativeInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<AdCreativeWithUrls>({
            resource: `/api/ad-creative/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getAdCreative(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AdCreativeWithUrls>({
            resource: `/api/ad-creative/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listAdCreatives(
        query?: Query<AdCreativeFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<AdCreativeWithUrls>>({
            resource: `/api/ad-creative/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async updateAdCreative(id: string, body: AdCreativeUpdate, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<AdCreativeWithUrls>({
            resource: `/api/ad-creative/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteAdCreative(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<AdCreative>({
            resource: `/api/ad-creative/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async setAdCreativeEvent(id: string, body: AdCreativeEventInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<Pick<AdCreativeEventInit, 'type'>>({
            resource: `/api/ad-creative/${id}/event`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getAdBreak(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AdBreak>({
            resource: `/api/ad-break/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listAdBreaks(
        query?: Query<AdBreakFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<AdBreak>>({
            resource: `/api/ad-break/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createAdBreak(body: Omit<AdBreakInit, 'id'>, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<AdBreak>({
            resource: `/api/ad-break/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteAdBreak(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<AdBreak>({
            resource: `/api/ad-break/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async getAdStorage(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AdStorageStatus>({
            resource: `/api/ad-storage`,
            optionsOverrides,
        })
        return result.body
    }
    async createScte104Injection(body: Scte104Injection, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Scte104InjectionResult>({
            resource: `/api/scte104-injection`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getTls(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<TlsCertRead>({
            resource: `/api/tls`,
            optionsOverrides,
        })
        return result.body
    }
    async setTls(body: TlsCertWrite, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<TlsCertRead>({
            resource: `/api/tls`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async syncTls(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<TlsCertRead>({
            resource: `/api/tls/sync`,
            optionsOverrides,
        })
        return result.body
    }
    async getGlobalsettings(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<GlobalSettings>({
            resource: `/api/globalsettings`,
            optionsOverrides,
        })
        return result.body
    }
    async setGlobalsettings(body: GlobalSettings, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<GlobalSettings>({
            resource: `/api/globalsettings`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteGlobalsettings(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/globalsettings`,
            optionsOverrides,
        })
        return result.body
    }
    async testBackupExternalS3s(body: S3ConfigWithPath, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/backup/externalS3/test`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async createBackup(body: BackupInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Record<string, any>>({
            resource: `/api/backup`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getRegion(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Region>({
            resource: `/api/region/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listRegions(
        query?: Query<RegionFilter, SortOrder<RegionSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Region>>({
            resource: `/api/region/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createRegion(body: RegionInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Region>({
            resource: `/api/region/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async setRegionDefaultRegion(
        body: {
            id?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<Pick<Region, 'id' | 'default_region'>>({
            resource: `/api/region/default-region`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteRegion(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Region>({
            resource: `/api/region/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async getImage(name: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ImageDetails>({
            resource: `/api/image/${name}`,
            optionsOverrides,
        })
        return result.body
    }
    async createImage(body: UpdateImageRequest, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<string>({
            resource: `/api/image/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteImage(name: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<string>({
            resource: `/api/image/${name}`,
            optionsOverrides,
        })
        return result.body
    }
    async getMedia(id: string, optionsOverrides: Partial<RequestOptions> = { json: false }) {
        const result = await this._get<Buffer>({
            resource: `/api/media/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceInternalStatuses(secret: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<InternalApplianceStatus[]>({
            resource: `/api/appliance/internal-statuses`,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async listApplianceSummaries(
        query?: Query<ApplianceSummaryFilter, SortOrder<ApplianceSummarySortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ApplianceSummary>>({
            resource: `/api/appliance/summary`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listAppliances(
        query?: Query<ApplianceFilter, SortOrder<ListApplianceSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Appliance>>({
            resource: `/api/appliance/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceRegisteredTypes(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<ApplianceType>>({
            resource: `/api/appliance/registered-types`,
            optionsOverrides,
        })
        return result.body
    }
    async clearApplianceConfig(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/config/clear`,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceNdiSources(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<NdiSource>>({
            resource: `/api/appliance/${id}/ndi-sources`,
            optionsOverrides,
        })
        return result.body
    }
    async getAppliance(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Appliance>({
            resource: `/api/appliance/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async upgradeAppliance(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<UpgradeCommandReceipt>({
            resource: `/api/appliance/${id}/upgrade`,
            optionsOverrides,
        })
        return result.body
    }
    async recreateApplianceTunnels(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Appliance>({
            resource: `/api/appliance/${id}/tunnels/recreate`,
            optionsOverrides,
        })
        return result.body
    }
    async restartAppliance(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Appliance>({
            resource: `/api/appliance/${id}/restart`,
            optionsOverrides,
        })
        return result.body
    }
    async upgradeImageAppliance(
        id: string,
        body: UpgradeImageArguments,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/upgrade-image`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async commandAppliance(id: string, body: ApplianceCommandInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<CommandReceipt>({
            resource: `/api/appliance/${id}/command`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceCommands(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ApplianceCommandInfo[]>({
            resource: `/api/appliance/${id}/command`,
            optionsOverrides,
        })
        return result.body
    }
    async getAppliancePorts(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AppliancePhysicalPortInfo>({
            resource: `/api/appliance/${id}/ports`,
            optionsOverrides,
        })
        return result.body
    }
    async setAppliancePorts(id: string, body: SharedPort[], optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._patch<SharedPort[]>({
            resource: `/api/appliance/${id}/ports`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateAppliance(id: string, body: UpdateAppliancePayload, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Appliance>({
            resource: `/api/appliance/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteAppliance(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/appliance/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async proxyApplianceGet(id: string, path: string, optionsOverrides: Partial<RequestOptions> = { json: false }) {
        const result = await this._get<Buffer>({
            resource: `/api/appliance/${id}/proxy${path}`,
            optionsOverrides,
        })
        return result.body
    }
    async proxyAppliancePost(
        id: string,
        path: string,
        body: any,
        optionsOverrides: Partial<RequestOptions> = { json: false }
    ) {
        const result = await this._post<Buffer>({
            resource: `/api/appliance/${id}/proxy${path}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async proxyAppliancePut(
        id: string,
        path: string,
        body: any,
        optionsOverrides: Partial<RequestOptions> = { json: false }
    ) {
        const result = await this._put<Buffer>({
            resource: `/api/appliance/${id}/proxy${path}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async proxyApplianceDelete(id: string, path: string, optionsOverrides: Partial<RequestOptions> = { json: false }) {
        const result = await this._delete<Buffer>({
            resource: `/api/appliance/${id}/proxy${path}`,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceInputs(
        id: string,
        query?: Query<void, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ApplianceInputInfo>>({
            resource: `/api/appliance/${id}/inputs`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listApplianceOutputs(
        id: string,
        query?: Query<void, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<ApplianceOutputInfo>>({
            resource: `/api/appliance/${id}/outputs`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listAppliancePcaps(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<Pcap>>({
            resource: `/api/appliance/${id}/pcap/`,
            optionsOverrides,
        })
        return result.body
    }
    async getAppliancePcap(
        applianceId: string,
        pcapId: string,
        optionsOverrides: Partial<RequestOptions> = { json: false }
    ) {
        const result = await this._get<Buffer>({
            resource: `/api/appliance/${applianceId}/pcap/${pcapId}`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteAppliancePcap(applianceId: string, pcapId: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/appliance/${applianceId}/pcap/${pcapId}`,
            optionsOverrides,
        })
        return result.body
    }
    async listGeoAppliances(
        query?: Query<GeoApplianceFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<GeoAppliance>>({
            resource: `/api/geoAppliance/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listTunnels(query?: Query<TunnelFilter, SortOrder<string>>, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<Tunnel>>({
            resource: `/api/tunnel/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listTunnelOutputs(
        id: string,
        query?: Query<void, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<TunnelOutputInfo>>({
            resource: `/api/tunnel/${id}/outputs`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createApplianceAllocation(body: AllocateApplianceRequest, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<CoreVideoApplianceAllocation>({
            resource: `/api/appliance-allocation`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getSanity(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<SanityStatus>({
            resource: `/api/sanity`,
            optionsOverrides,
        })
        return result.body
    }
    async getTestSleep(s: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<SleepResult>({
            resource: `/api/test/sleep/${s}`,
            optionsOverrides,
        })
        return result.body
    }
    async setStatefulsetScale(name: string, body: ScaleOperation, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<ScaleOperation>({
            resource: `/api/k8s/statefulset/${name}/scale`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getStatefulsetScale(name: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ScaleStatus>({
            resource: `/api/k8s/statefulset/${name}/scale`,
            optionsOverrides,
        })
        return result.body
    }
    async setStatefulsetTag(
        name: string,
        container: string,
        body: ImageTagOperation,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<ImageTagOperation>({
            resource: `/api/k8s/statefulset/${name}/${container}/tag`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getStatefulsetTag(name: string, container: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<GetImageTagResult>({
            resource: `/api/k8s/statefulset/${name}/${container}/tag`,
            optionsOverrides,
        })
        return result.body
    }
    async setDeploymentTag(
        name: string,
        container: string,
        body: ImageTagOperation,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<ImageTagOperation>({
            resource: `/api/k8s/deployment/${name}/${container}/tag`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getDeploymentScale(name: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ScaleStatus>({
            resource: `/api/k8s/deployment/${name}/scale`,
            optionsOverrides,
        })
        return result.body
    }
    async setDeploymentScale(name: string, body: ScaleOperation, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<void>({
            resource: `/api/k8s/deployment/${name}/scale`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getDeployment(name: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<K8SDeployment>({
            resource: `/api/k8s/deployment/${name}`,
            optionsOverrides,
        })
        return result.body
    }
    async getPodStatus(name: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<PodStatus>({
            resource: `/api/k8s/pod/${name}/status`,
            optionsOverrides,
        })
        return result.body
    }
    async getPodLogs(name: string, containerName: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<string>({
            resource: `/api/k8s/pod/${name}/logs/${containerName}`,
            optionsOverrides,
        })
        return result.body
    }
    async deletePod(name: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Pod>({
            resource: `/api/k8s/pod/${name}`,
            optionsOverrides,
        })
        return result.body
    }
    async getPod(name: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Pod>({
            resource: `/api/k8s/pod/${name}`,
            optionsOverrides,
        })
        return result.body
    }
    async listPods(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Pod[]>({
            resource: `/api/k8s/pod/`,
            optionsOverrides,
        })
        return result.body
    }
    async listKubernetesNodes(
        query?: Query<KubernetesNodeFilter, SortOrder<ListKubernetesNodeSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<KubernetesNode>>({
            resource: `/api/k8s/node/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listIngresses(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Ingress[]>({
            resource: `/api/k8s/ingress/`,
            optionsOverrides,
        })
        return result.body
    }
    async listResourceUsages(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<KubernetesNodeResourceUsage[]>({
            resource: `/api/k8s/resourceUsage/`,
            optionsOverrides,
        })
        return result.body
    }
    async getKubernetesNode(regionId: string, name: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<KubernetesNode>({
            resource: `/api/k8s/region/${regionId}/node/${name}`,
            optionsOverrides,
        })
        return result.body
    }
    async updateKubernetesNode(
        regionId: string,
        name: string,
        body: UpdateKubernetesNodePayload,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<KubernetesNode>({
            resource: `/api/k8s/region/${regionId}/node/${name}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listRegionKubernetesNodes(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<KubernetesNode[]>({
            resource: `/api/k8s/region/${id}/node/`,
            optionsOverrides,
        })
        return result.body
    }
    async getRegionVideoScale(regionId: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ScaleStatus>({
            resource: `/api/k8s/region/${regionId}/videoscale/`,
            optionsOverrides,
        })
        return result.body
    }
    async setRegionVideoScale(regionId: string, body: ScaleOperation, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<ScaleOperation>({
            resource: `/api/k8s/region/${regionId}/videoscale/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getRegionThumbScale(regionId: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ScaleStatus>({
            resource: `/api/k8s/region/${regionId}/thumbscale/`,
            optionsOverrides,
        })
        return result.body
    }
    async setRegionThumbScale(regionId: string, body: ScaleOperation, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<ScaleOperation>({
            resource: `/api/k8s/region/${regionId}/thumbscale/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listAlarms(
        query?: Query<AlarmFilter, SortOrder<ListAlarmSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<AlarmWithImpact>>({
            resource: `/api/alarm/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async setAlarm(alarmId: string, body: AlarmUpdate, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<Pick<AlarmWithImpact, 'alarmId'>>({
            resource: `/api/alarm/${alarmId}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async backupMonitorAlarms(
        body: BackupMonitorAlarm[],
        secret: string,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<BackupMonitorAlarm[]>({
            resource: `/api/alarm/backup-monitor/`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async getPort(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<PhysicalPort>({
            resource: `/api/port/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listPorts(
        query?: Query<PortFilter, SortOrder<ListPortSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<PhysicalPort>>({
            resource: `/api/port/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async login(body: LoginRequest, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LoginResult>({
            resource: `/api/login/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listLoginMethods(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<LoginMethod[]>({
            resource: `/api/login-methods`,
            optionsOverrides,
        })
        return result.body
    }
    async getSsoMetadataSaml(
        regularQueryParams?: {
            url?: string | string[]
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<SamlMetadata>({
            resource: `/api/sso-metadata/saml`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async getSsoMetadataOidc(
        regularQueryParams?: {
            url?: string | string[]
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<OidcMetadata>({
            resource: `/api/sso-metadata/oidc`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async impersonate(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LoginResult>({
            resource: `/api/impersonate/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async unimpersonate(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<LoginResult>({
            resource: `/api/unimpersonate`,
            optionsOverrides,
        })
        return result.body
    }
    async getCurrentUser(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<AuthenticatedUser>({
            resource: `/api/current-user`,
            optionsOverrides,
        })
        return result.body
    }
    async totpCurrentUsers(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<
            Required<{
                uri?: string
            }>
        >({
            resource: `/api/current-user/totp`,
            optionsOverrides,
        })
        return result.body
    }
    async setCurrentUserTotpVerify(
        body: {
            token?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<Record<string, any>>({
            resource: `/api/current-user/totp/verify`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteCurrentUserTotps(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<void>({
            resource: `/api/current-user/totp`,
            optionsOverrides,
        })
        return result.body
    }
    async logout(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<SuccessResult>({
            resource: `/api/logout/`,
            optionsOverrides,
        })
        return result.body
    }
    async getCheckSuperAuthentication(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<void>({
            resource: `/api/check-super-authentication`,
            optionsOverrides,
        })
        return result.body
    }
    async getAuthRequest(role: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<void>({
            resource: `/api/auth/request/${role}`,
            optionsOverrides,
        })
        return result.body
    }
    async listUsers(
        query?: Query<UserFilter, SortOrder<ListUserSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<User>>({
            resource: `/api/user/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getUser(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<User>({
            resource: `/api/user/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async createUser(body: NewUser, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<User>({
            resource: `/api/user/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteUser(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/user/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async updateUser(id: string, body: UserUpdate, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<User>({
            resource: `/api/user/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getUserSettings(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<UserSettings>({
            resource: `/api/user/${id}/settings`,
            optionsOverrides,
        })
        return result.body
    }
    async setUserSettings(id: string, body: UserSettings, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<UserSettings>({
            resource: `/api/user/${id}/settings`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateGroup(id: string, body: GroupUpdate, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Group>({
            resource: `/api/group/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async createGroup(body: GroupInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Group>({
            resource: `/api/group/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listGroups(
        query?: Query<GroupFilter, SortOrder<ListGroupSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Group>>({
            resource: `/api/group/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getGroup(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Group>({
            resource: `/api/group/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteGroup(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Group>({
            resource: `/api/group/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async getGroupCoreSecret(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<CoreSecret>({
            resource: `/api/group/${id}/core-secret`,
            optionsOverrides,
        })
        return result.body
    }
    async setGroupCoreSecret(id: string, body: CoreSecret, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<CoreSecret>({
            resource: `/api/group/${id}/core-secret`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getInputServiceOverview(
        id: string,
        query?: Query<InputGraphFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ServiceOverview>({
            resource: `/api/input/${id}/service-overview`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getServiceGraphConfig(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<EnhancedInputConfig>({
            resource: `/api/service-graph/config`,
            optionsOverrides,
        })
        return result.body
    }
    async createInput(body: InputInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Input>({
            resource: `/api/input/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getInputStreamGraph(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<InputStreamGraphDebug>({
            resource: `/api/input/${id}/stream-graph`,
            optionsOverrides,
        })
        return result.body
    }
    async listInputs(
        query?: Query<InputFilter, SortOrder<ListInputSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Input>>({
            resource: `/api/input/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getInput(
        id: string,
        query?: Query<InputFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<Input>({
            resource: `/api/input/${id}`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async updateInput(id: string, body: InputUpdate, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Input>({
            resource: `/api/input/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async pcapInput(id: string, body: InputPcapRequest, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<InputPcapResponse>({
            resource: `/api/input/${id}/pcap/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async sendToOutputsInput(
        id: string,
        body: SendToOutputRecipientListParams,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<Record<string, any>>({
            resource: `/api/input/${id}/sendToOutputs`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateRecipientsInput(
        id: string,
        body: InputRecipientsUpdate,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<Record<string, any>>({
            resource: `/api/input/${id}/updateRecipients`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async rerouteInput(id: string, body: void | RerouteInputPayload, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Input>({
            resource: `/api/input/${id}/reroute`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async enableInputPreview(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/input/${id}/preview/enable`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteInput(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<DeletedInput>({
            resource: `/api/input/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteInputs(
        regularQueryParams?: {
            ids?: string[]
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._delete<BatchDeleteResult>({
            resource: `/api/input`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async listInputDistributions(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<GroupInputPermission[]>({
            resource: `/api/input/${id}/distribution/`,
            optionsOverrides,
        })
        return result.body
    }
    async setInputDistributions(
        id: string,
        body: (GroupInputPermission | GroupListInputPermission)[],
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._put<GroupInputPermission[]>({
            resource: `/api/input/${id}/distribution/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getInputHealth(
        id: string,
        query?: Query<InputFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<InputStatus>({
            resource: `/api/input/${id}/health/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getInputHlsAccess(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<void>({
            resource: `/api/input/${id}/hls-access`,
            optionsOverrides,
        })
        return result.body
    }
    async getChannelCheckThumbReadAccess(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<void>({
            resource: `/api/channel/${id}/check-thumb-read-access`,
            optionsOverrides,
        })
        return result.body
    }
    async setInputAdminStatuses(body: InputAdminStatusUpdate[], optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._patch<Input[]>({
            resource: `/api/input/admin-status`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateOutput(id: string, body: OutputUpdate, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Output>({
            resource: `/api/output/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async setOutputInput(id: string, body: OutputSwitchInput, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<Output>({
            resource: `/api/output/${id}/input`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async createOutput(body: OutputInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Output>({
            resource: `/api/output/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listOutputs(
        query?: Query<OutputFilter, SortOrder<ListOutputSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Output>>({
            resource: `/api/output/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getOutput(
        id: string,
        query?: Query<OutputFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<Output>({
            resource: `/api/output/${id}`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getOutputHealth(
        id: string,
        query?: Query<OutputFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<OutputStatus>({
            resource: `/api/output/${id}/health/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async deleteOutput(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Entity>({
            resource: `/api/output/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async deleteOutputs(
        regularQueryParams?: {
            ids?: string[]
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._delete<BatchDeleteResult>({
            resource: `/api/output`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async setOutputAdminStatuses(body: OutputAdminStatusUpdate[], optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._patch<Output[]>({
            resource: `/api/output/admin-status`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getDashboardBitrates(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<MaxBitrates>({
            resource: `/api/dashboard/bitrates/`,
            optionsOverrides,
        })
        return result.body
    }
    async getThumbRoutes(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<string>({
            resource: `/internal/thumb-routes`,
            optionsOverrides,
        })
        return result.body
    }
    async region(id: string, body: ExternalRegionMessage, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<JsonRpcSuccessResponse<Record<string, any>[]>>({
            resource: `/internal/region/${id}/rpc`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listRawThumbRoutes(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ThumbRoute[]>({
            resource: `/api/raw-thumb-routes`,
            optionsOverrides,
        })
        return result.body
    }
    async getBuildInfo(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<BuildInfo>({
            resource: `/api/build-info`,
            optionsOverrides,
        })
        return result.body
    }
    async listRpcSessions(
        query?: Query<RpcSessionFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<RpcSession[]>({
            resource: `/api/rpc-session/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async deleteRpcSession(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<RpcSession>({
            resource: `/api/rpc-session/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listAlarmLogs(
        query?: Query<AlarmLogFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Alarm>>({
            resource: `/api/alarm-log/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async cloudApplianceAuditLogs(body: CloudApplianceAuditLogEntry, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/audit-log/cloud-appliance/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async beginAuditLogSystemUpgrades(body: BeginSystemUpgradeEvent, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<BeginSystemUpgradeResponse>({
            resource: `/api/audit-log/system/upgrade/begin`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async completeAuditLogSystemUpgrades(
        body: CompleteSystemUpgradeEvent,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<AuditLog>({
            resource: `/api/audit-log/system/upgrade/complete`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async listAuditLogs(query?: Query<AuditFilter, SortOrder<string>>, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<AuditLog>>({
            resource: `/api/audit-log/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listAdAuditLogs(
        query?: Query<AdAuditFilter, SortOrder<string>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<AdAuditLogMessage>>({
            resource: `/api/ad-audit-log/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getOutputRecipientList(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<OutputRecipientList>({
            resource: `/api/outputRecipientList/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listOutputRecipientListOutputs(
        id: string,
        query?: Query<OutputFilter, SortOrder<ListOutputSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Output>>({
            resource: `/api/outputRecipientList/${id}/outputs`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listOutputRecipientListOutputsNotInLists(
        id: string,
        query?: Query<OutputFilter, SortOrder<ListOutputSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Output>>({
            resource: `/api/outputRecipientList/${id}/outputsNotInList`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listOutputRecipientLists(
        query?: Query<OutputListFilter, SortOrder<OutputListSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<OutputRecipientList>>({
            resource: `/api/outputRecipientList/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createOutputRecipientList(body: OutputRecipientListInit, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<OutputRecipientList>({
            resource: `/api/outputRecipientList/`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateOutputRecipientList(
        id: string,
        body: OutputRecipientListUpdate,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<OutputRecipientList>({
            resource: `/api/outputRecipientList/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteOutputRecipientList(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<OutputRecipientList>({
            resource: `/api/outputRecipientList/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listOutputAndRecipientLists(
        query?: Query<OutputFilter, SortOrder<ListOutputSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<OutputOrRecipientList>>({
            resource: `/api/outputAndRecipientList/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listGroupRecipientLists(
        query?: Query<GroupRecipientListFilter, SortOrder<GroupRecipientListSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<GroupRecipientList>>({
            resource: `/api/groupRecipientList/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getGroupRecipientList(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<GroupRecipientList>({
            resource: `/api/groupRecipientList/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listGroupRecipientListGroups(
        id: string,
        query?: Query<GroupFilter, SortOrder<ListGroupSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Group>>({
            resource: `/api/groupRecipientList/${id}/groups`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listGroupRecipientListGroupsNotInLists(
        id: string,
        query?: Query<GroupFilter, SortOrder<ListGroupSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Group>>({
            resource: `/api/groupRecipientList/${id}/groupsNotInList`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async createGroupRecipientList(
        body: GroupRecipientListInit,
        query?: Query<GroupFilter, SortOrder<ListGroupSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<GroupRecipientList>({
            resource: `/api/groupRecipientList/`,
            query,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateGroupRecipientList(
        id: string,
        body: GroupRecipientListUpdate,
        query?: Query<GroupFilter, SortOrder<ListGroupSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<GroupRecipientList>({
            resource: `/api/groupRecipientList/${id}`,
            query,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteGroupRecipientList(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<GroupRecipientList>({
            resource: `/api/groupRecipientList/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listGroupAndRecipientLists(
        query?: Query<GroupFilter, SortOrder<ListGroupSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<GroupOrGroupRecipientList>>({
            resource: `/api/groupAndRecipientList/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getCoreSecret(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<CoreSecret>({
            resource: `/internal/core-secret`,
            optionsOverrides,
        })
        return result.body
    }
    async getBillingReport(
        regularQueryParams?: {
            startDate?: string
            endDate?: string
            format?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<BillingReport>({
            resource: `/api/billing-report`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async getUsageReport(query?: Query<GetUsageReportFilter, any>, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<UsageReport>({
            resource: `/api/usage-report`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listNetworks(
        query?: Query<NetworkFilter, SortOrder<NetworkSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Network>>({
            resource: `/api/network`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getNetwork(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Network>({
            resource: `/api/network/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async createNetwork(body: Omit<Network, 'id'>, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Network>({
            resource: `/api/network`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async updateNetwork(id: string, body: Omit<Network, 'id'>, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Network>({
            resource: `/api/network/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async deleteNetwork(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._delete<Network>({
            resource: `/api/network/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async listTags(query?: Query<TagFilter, SortOrder<'name'>>, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ListResult<MetadataTag>>({
            resource: `/api/tag/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async listServices(
        query?: Query<ServiceFilter, SortOrder<ListServiceSortableField>>,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<ListResult<Service>>({
            resource: `/api/service/`,
            query,
            optionsOverrides,
        })
        return result.body
    }
    async getService(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Service>({
            resource: `/api/service/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async updateService(id: string, body: ServiceUpdate, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Service>({
            resource: `/api/service/${id}`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getGrafanaDashboardsHome(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<Record<string, any>>({
            resource: `/grafana/api/dashboards/home`,
            optionsOverrides,
        })
        return result.body
    }
    async listGrafanaDashboards(
        regularQueryParams?: {
            query?: string
        },
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._get<GrafanaDashboard[]>({
            resource: `/grafana/api/search`,
            regularQueryParams,
            optionsOverrides,
        })
        return result.body
    }
    async setGrafanaUserHelpflags(flag: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._put<Record<string, any>>({
            resource: `/grafana/api/user/helpflags/${flag}`,
            optionsOverrides,
        })
        return result.body
    }
    async createGrafanaApiUserStarsDashboard(id: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<Record<string, any>>({
            resource: `/grafana/api/user/stars/dashboard/${id}`,
            optionsOverrides,
        })
        return result.body
    }
    async getHealthBackendAppliance(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<string>({
            resource: `/health-backend-appliance`,
            optionsOverrides,
        })
        return result.body
    }
    async registerAppliance(body: ApplianceRegistration, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<ApplianceRegistrationResponse>({
            resource: `/api/appliance/register`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getApplianceConfig(id: string, secret: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<ApplianceConfiguration>({
            resource: `/api/appliance/${id}/config`,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async sendApplianceVersionMessage(
        id: string,
        body: VersionMessage,
        secret: string,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/message/version`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async sendApplianceSrtStatsMessage(
        id: string,
        body: SrtStatsMessage[],
        secret: string,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/message/srt-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async sendApplianceRtmpStatsMessage(
        id: string,
        body: RtmpStatsMessage[],
        secret: string,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/message/rtmp-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async sendApplianceZixiBroadcasterStatsMessage(
        id: string,
        body: ZixiBroadcasterStatsMessage[],
        secret: string,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/message/zixi-broadcaster-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async sendApplianceAdStageStatsMessage(
        id: string,
        body: AdStageStatsMessage[],
        secret: string,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/message/ad-stage-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async sendApplianceProgressMessage(
        id: string,
        cmdId: string,
        body: ApplianceCommandProgress,
        secret: string,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/message/command/${cmdId}/progress`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async messageAppliance(
        id: string,
        body: Message<any, string>,
        secret: string,
        optionsOverrides: Partial<RequestOptions> = {}
    ) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/message`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async logAppliance(id: string, body: LogBatch, secret: string, optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._post<void>({
            resource: `/api/appliance/${id}/log`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        })
        return result.body
    }
    async getCoreSecretAppliance(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<CoreSecret>({
            resource: `/internal/core-secret-appliance`,
            optionsOverrides,
        })
        return result.body
    }
    async getThumbWriteAccess(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<void>({
            resource: `/internal/auth/thumb-write-access`,
            optionsOverrides,
        })
        return result.body
    }
    async getHealthStreamMonitor(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<string>({
            resource: `/health-stream-monitor`,
            optionsOverrides,
        })
        return result.body
    }
    async getApplianceSoftware(optionsOverrides: Partial<RequestOptions> = { json: false }) {
        const result = await this._get<Buffer>({
            resource: `/api/appliance/software`,
            optionsOverrides,
        })
        return result.body
    }
    async applianceSoftware(body: GetSoftwareRequest, optionsOverrides: Partial<RequestOptions> = { json: false }) {
        const result = await this._post<Buffer>({
            resource: `/api/appliance/software`,
            body,
            optionsOverrides,
        })
        return result.body
    }
    async getHealthAdService(optionsOverrides: Partial<RequestOptions> = {}) {
        const result = await this._get<string>({
            resource: `/health-ad-service`,
            optionsOverrides,
        })
        return result.body
    }
    public get baseUrl() {
        if (Date.now() - this._baseUrlLastSet > 60000) {
            this.baseUrl = this.baseUrls.reset()
        }
        return this._baseUrl
    }
    set baseUrl(url: string) {
        this._baseUrlLastSet = Date.now()
        this._baseUrl = url
    }
    public async _get<T>(params: CallParams) {
        return this._call<T>('GET', params)
    }
    public async _post<T>(params: CallParams) {
        return this._call<T>('POST', params)
    }
    protected async _put<T>(params: CallParams) {
        return this._call<T>('PUT', params)
    }
    protected async _delete<T>(params: CallParams) {
        return this._call<T>('DELETE', params)
    }
    protected async _patch<T>(params: CallParams) {
        return this._call<T>('PATCH', params)
    }
    private _call<T>(method: RequestOptions['method'], params: CallParams) {
        const queryParams = Object.assign({}, params.regularQueryParams)
        if (params.query) {
            const queryObject = toQueryParams(params.query)
            Object.assign(queryParams, queryObject)
        }
        const queryString = Object.entries(queryParams)
            .reduce<string[]>((acc, [key, value]) => {
                return [
                    ...acc,
                    value === undefined || value === null
                        ? `${this.encode(key)}=`
                        : `${this.encode(key)}=${this.encode(value)}`,
                ]
            }, [])
            .join('&')
        const url = `${this.baseUrl}${params.resource}?${queryString}`
        return this.request<T>({
            method,
            url,
            body: params.body,
            optionsOverrides: params.optionsOverrides,
        })
    }
    private async request<T>(params: RequestParams, attempt = 1): Promise<RequestResult<T>> {
        try {
            return await this._request<T>(params)
        } catch (err) {
            if (this.baseUrls.length > attempt) {
                this.baseUrl = this.baseUrls.next().value
                return this.request<T>(params, attempt + 1)
            }
            throw err
        }
    }
    /// https://github.com/axios/axios/blob/master/lib/helpers/buildURL.js
    private encode(val: string | number | boolean): string {
        return encodeURIComponent(val)
            .replace(/%3A/gi, ':')
            .replace(/%24/g, '$')
            .replace(/%2C/gi, ',')
            .replace(/%20/g, '+')
            .replace(/%5B/gi, '[')
            .replace(/%5D/gi, ']')
    }
    protected abstract _request<T>(params: RequestParams): Promise<RequestResult<T>>
}
